export default __webpack_public_path__ + "static/media/sukate.8663fe51.jpeg";